import React, {useEffect} from "react"
import SpinnerControl from "../components/SpinnerControl/SpinnerControl";
import {AppContext} from "../context/AppContext";
import HambergerForHiddenNav from "../components/HambergerForHiddenNav/HambergerForHiddenNav.component";
import {BackwordArrow} from "../../assets/Arrows";
import {Helmet} from 'react-helmet';
import {CartWithNumberDtChangeColor, CartWithNumberMo} from "../../assets/CartWithNumber";
import Header from "../components/Header/Header.component";
import {useNavigate} from "react-router-dom";
import "./BrandArchivePage.scss";
import BrandArchiveComponent from "../components/BrandArchive/BrandArchive.component";
import FooterIncenseVer from "../components/Footer/FooterIncenseVer.component";
import LogoSvg from "../../img/brandArchive/collins_logo_b 1.svg"
import HambergerForHiddenNavColor from "../components/HambergerForHiddenNav/HambergerForHiddenNavColor";

function BrandArchivePage() {
    const {spinnerStore, cartDataStore, bannerDataStore} =
        React.useContext(AppContext);
    const navigate = useNavigate()

    const handleChangeHeaderColor = () => {
        if (window.scrollY > 15) {
            document.querySelector('.header-logo-dt')?.classList.add('transparent');
        } else {
            document.querySelector('.header-logo-dt')?.classList.remove('transparent');
        }
    };
    useEffect(() => {
        cartDataStore.callCartCount()
        window.addEventListener('scroll', handleChangeHeaderColor);
        document.querySelector('body').style.backgroundColor = "#ECE0CE"
        return () => {
            document.querySelector('body').style.backgroundColor = "#fffff5"
            window.removeEventListener('scroll', handleChangeHeaderColor);

        }
    }, [])

    return (
        <SpinnerControl isSpinnerShow={spinnerStore.isSpinnerShow}>
            <Helmet>
                <title>콜린스 - Maker&apos;s Note</title>
            </Helmet>
            <div className={"collins-brand-archive-wrapper"}>
                <Header
                    callCartCount={cartDataStore.callCartCount}
                    // 사실 아래의 props는 필요 없어짐 -> 진짜 될지 해보자
                    // setIsSpinnerShow = {spinnerStore.isSpinnerShow}
                    isSearchIconColor={'#ECE0CE'}
                    topBannerData={{data: bannerDataStore.topBannerData}}
                    topBannerEnabled={
                        bannerDataStore.topBannerData && bannerDataStore.topBannerData.enabled
                    }
                    isHeaderBgColorChange={true}
                    leftContent={
                        <>
                            <HambergerForHiddenNavColor className="dt" color={"#ECE0CE"}/>
                            <div className="mo">
                                <div
                                    style={{cursor: 'pointer', display: "flex"}}
                                    onClick={() => navigate("/makersnote")}
                                >
                                    <BackwordArrow/>
                                </div>

                            </div>
                        </>
                    }
                    centerContent={
                        <>
                            <img
                                src={LogoSvg}
                                className="header-logo fixed_logo header-logo-dt dt"
                                style={{
                                    pointerEvents: 'all',
                                    cursor: 'pointer',
                                }}
                                onClick={(e) => {
                                    navigate('/')
                                }}
                            />
                        </>
                    }
                    rightContent={
                        <>
                            <div
                                className=" dt"
                                onClick={() => {
                                    navigate('/cart');
                                }}
                            >
                                <CartWithNumberDtChangeColor number={cartDataStore.cartQuantity} color={"#ECE0CE"}
                                                             fontColor={"#604448"}/>
                            </div>
                            <div
                                className="flex  mo"
                                // style ={{display: 'flex'}}
                            >
                                <div
                                    className="mo "
                                    onClick={() => {
                                        navigate('/cart');
                                    }}
                                    style={{
                                        marginRight: '10px',
                                    }}
                                >
                                    <CartWithNumberMo number={cartDataStore.cartQuantity}/>
                                </div>
                                <HambergerForHiddenNav/>
                            </div>
                        </>
                    }
                />
                <BrandArchiveComponent/>
                <FooterIncenseVer/>
            </div>
        </SpinnerControl>
    )
}

export default BrandArchivePage;
